import { factory } from '../factory';
export const filterRoutesByScreenType = (screenType = factory.SCREEN_TYPE.DESKTOP) => (routes = []) => routes.filter(route => Array.isArray(route.screenTypes) && route.screenTypes.includes(screenType));